import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface BenchmarkMercado {
  codigo: string | null;
  tipo: string;
  indisponivel: boolean;
  origem_recusou: boolean;
  motivo?: string;
  descricao?: string | null;
  amostras?: number;
  minimo?: number | null;
  mediana?: number | null;
  media?: number | null;
  maximo?: number | null;
  periodo_inicio?: string | null;
  periodo_fim?: string | null;
}

interface Envelope<T> { success: boolean; data: T }

/**
 * Benchmark de preços por código CATMAT/CATSER. Só busca quando habilitado e com código.
 */
export function useBenchmarkMercado(codigo: string | null | undefined, tipo: 'material' | 'servico', enabled: boolean) {
  return useQuery({
    queryKey: ['mercado-benchmark', codigo, tipo],
    enabled: Boolean(codigo) && enabled,
    staleTime: 24 * 60 * 60 * 1000,
    queryFn: async () => {
      const envelope = await api.get<Envelope<BenchmarkMercado>>(
        `/mercado/benchmark?codigo=${encodeURIComponent(String(codigo))}&tipo=${tipo}`
      );
      return envelope.data;
    },
  });
}
